interface Props {
  mensagem: string;
  icone: string;
  aoRecarregar?: () => void;
}

export default function EstadoErro({ mensagem, icone, aoRecarregar }: Props) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background-100 px-4 py-8">
      <div className="w-full max-w-[420px] overflow-hidden rounded-lg border border-secondary-200 bg-white">
        <div className="h-[10px] w-full bg-primary-500" />
        <div className="p-6 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
            <i className={`${icone} text-2xl`} />
          </span>
          <p className="mt-4 text-base text-foreground-800">{mensagem}</p>
          {aoRecarregar && (
            <button
              type="button"
              onClick={aoRecarregar}
              className="mt-6 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600"
            >
              Tentar novamente
            </button>
          )}
        </div>
      </div>
    </div>
  );
}